<h2 mat-dialog-title>{{'filters.filter_settings' | translate}}</h2>

<mat-dialog-content>
  <div class="pt-2">
    <section class="mt-1 mb-3 rounded m-auto w-100" id="section">
      <form [formGroup]="filterForm">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{'displayName' | translate}}</mat-label>
          <input matInput type="text" class="form-control" placeholder="{{'displayName' | translate}}" formControlName="displayName">
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100 p-0">
          <mat-label>{{'reports.type' | translate}}</mat-label>
          <mat-select formControlName="type">
            @for (t of typeOptions; track t) {
              <mat-option [value]="t.type" [disabled]="t.disabled">{{t.translation | translate}}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{'filters.key' | translate}}</mat-label>
          <input matInput type="text" class="form-control" placeholder="{{'filters.key' | translate}}" formControlName="field" required>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100 p-0">
          <mat-label>{{'filters.operator' | translate}}</mat-label>
          <mat-select formControlName="operator" required>
            @for (op of operatorOptions; track op) {
              <mat-option value="{{op.value}}">{{op.translation | translate}}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        @if (selectedType != 'boolean' && selectedType != 'date') {
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'filters.value' | translate}}</mat-label>
            @if (selectedType == 'string' || selectedType == 'geopoint' || selectedType == 'media') {
              <input matInput type="text" formControlName="value">
            }
            @if (selectedType == 'number') {
              <input matInput type="number" formControlName="value">
            }
            @if (selectedType == 'decimal') {
              <input matInput type="number" step="0.1" formControlName="value">
            }
            @if (selectedType == 'time') {
              <input matInput type="time" formControlName="value">
            }
            @if (selectedType == 'dateTime') {
              <input matInput type="datetime-local" formControlName="value" max="9999-12-31T23:59">
            }
            @if (!selectedType) {
              <input matInput type="text" formControlName="value">
            }
            <mat-hint>{{'filters.value_empty' | translate}}</mat-hint>
          </mat-form-field>
        }

        @if (selectedType == 'boolean') {
          <div class="form-control p-3 mb-3 d-flex justify-content-between">
            <label for="value">{{'filters.value' | translate}}</label>
            <mat-slide-toggle class="ms-5" formControlName="value"></mat-slide-toggle>
          </div>
        }

        @if (selectedType == 'date') {
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'filters.value' | translate}}</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="value" placeholder="{{'dd.mm.yyyy' | translate}}">
            <mat-hint>{{'dd.mm.yyyy' | translate}}</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        }

        <mat-form-field appearance="outline" class="w-100 p-0">
          <mat-label>{{'predicateFilter.options' | translate}}</mat-label>
          <mat-select formControlName="options" multiple>
            @for (opt of filterOptionsList; track opt) {
              <mat-option [value]="opt.value">{{opt.translation | translate}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </form>
    </section>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button style="color:var(--warmOrange);" (click)="onCancel();">
    {{'cancel' | translate}}
  </button>
  <button mat-button class="orange-button" (click)="onSave();">
    {{'apply' | translate}}
  </button>
</mat-dialog-actions>
